'use client'
import { SignIn } from '@clerk/nextjs'
import React from 'react'
import { Icon } from '@/ui/atoms/Icon'
import Image from 'next/image'
import { WelcomeLayout } from '@/ui/components/WelcomeLayout'
import { ClerkFormSkeleton } from '@/ui/components/WelcomeLayout/ClerkFormSkeleton'

export default function SignInPage() {
  return (
    <WelcomeLayout>
      <SignIn
        fallback={<ClerkFormSkeleton />}
        afterSignOutUrl={'/logout'}
        appearance={{ variables: { borderRadius: '8px' } }}
      />
    </WelcomeLayout>
  )
}
